export default __webpack_public_path__ + "static/media/typescript.c4105801.png";